export const SEARCH_URL = "/search";
export const SEARCH_DOCUMENTS_TYPES_FILTERS = "/documents/types";
export const SEARCH_KNOWLEDGE_SOURCES_FILTERS = "/knowledge/sources";

export const STATISTICS_USERS_ACTIVITY = "/stats/activity/users";
